import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import './index.sass';

const { block, el } = bem('feedback-form-success');

const FeedbackFormSuccess = () => {
    return (
        <div className={block()}>
            <div className={el('content')}>
                <div className={el('plane')} />
                <div className={el('message')}>
                    <div className={el('title')}>
                        <Text tag={'div'} serif>{`Сообщение успешно отправлено!`}
                        </Text>
                    </div>
                    <div className={el('description')}>
                        В скором времени мы свяжемся с вами
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeedbackFormSuccess;
